import { Link as RouterLink } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { Box, Button, Typography, Container } from '@mui/material';

const RootStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1)
}));

export default function Page404() {
  return (
    <RootStyle>
      <Container>
        <Box sx={{ maxWidth: 480, margin: 'auto', textAlign: 'center' }}>
          <Typography variant='h3' paragraph>
            Page not found!
          </Typography>
          <Typography sx={{ color: 'text.secondary' }}>
            Sorry, we couldn't find the page you're looking for.
          </Typography>
          <Box
            sx={{
              mt: 1
            }}
          >
            <Button to='/' size='large' variant='contained' component={RouterLink}>
              Return Home
            </Button>
          </Box>

        </Box>
      </Container>
    </RootStyle>
  );
}
